/* eslint-disable */

import httpClient from '@/utils/httpClient'

class ParkManagmentDriversRepository extends httpClient {
   resource = '/park_management/drivers';

   async getDrivers (params) {
     const response = await this.get(`${this.resource}`, { params })
     return response
   }

   async getDriverById (params) {
     const response = await this.get(`${this.resource}/id`, { params })
     return response?.driver ?? {}
   }

   async updateDriver (data) {
     const response = await this.put(`${this.resource}`, data)
     return response
   }

   async uploadPhotosDriver (driverId, data) {
     const response = await this.post(`${this.resource}/${driverId}/photos`, data)
     return response
   }

   async deletePhotosDriver (driverId, params) {
     const response = await this.delete(`${this.resource}/${driverId}/photos`, { params })
     return response
   }

   async saveDriversFromAggregator () {
     const response = await this.post(`${this.resource}/from-aggregator`)
     return response
   }

   async changeDriverRikStatus (data) {
     const response = await this.put(`${this.resource}/change-rik-status`, data)
     return response?.driver
   }

   async addNewCandidateDrivers (data) {
     const response = await this.post(`${this.resource}/candidates`, data)
     return response ?? {}
   }

   async getCandidateDrivers (params) {
     const response = await this.get(`${this.resource}`, { params })
     return response ?? []
   }

   async removeCandidateDrivers (id) {
     const response = await this.delete(`${this.resource}?driverId=${id}`)

     return response ?? {}
   }

   async addCandidateInTrial (data) {
     const response = await this.put(`${this.resource}/change-category`, data)

     return response ?? {}
   }

   async approveCandidate (driverId, data) {
     const response = await this.post(`${this.resource}/candidates/approve/${driverId}`, data)

     return response ?? {}
   }
}

export default ParkManagmentDriversRepository
